import { service } from '@ember/service'
import Component from '@glimmer/component'
import type PromoService from 'teacher-ui-client/services/promo'
import { LinkTo } from '@ember/routing'
import { t } from 'ember-intl'
import {
  InlineAlert,
  AlertType,
  InlineAlertSubtitle,
  InlineAlertTitle,
} from 'teacher-ui-client/components/inline-alert'

export class MSUpsell extends Component {
  @service promo!: PromoService

  <template>
    {{#if this.promo.shouldShowMSUpsell}}
      <InlineAlert @type={{AlertType.Success}}>
        <InlineAlertTitle>{{t "promo.msUpsell.intro"}}</InlineAlertTitle>
        <InlineAlertSubtitle>
          {{t "promo.msUpsell.getStarted"}}
          <LinkTo @route="manage.classes.index" @model="maths">{{t "promo.msUpsell.settingUp"}}</LinkTo>{{t
            "promo.msUpsell.youCanAlso"
          }}
          <LinkTo @route="subscription-type.copy-classes" @model="maths">{{t "promo.msUpsell.copyClasses"}}</LinkTo>
          {{t "promo.msUpsell.ifYouHaveOne"}}
        </InlineAlertSubtitle>
      </InlineAlert>
    {{/if}}
  </template>
}
